import { sanitizeDocument } from './sanitizeDocument';

const FIRST_CHECK_DIGIT_WEIGHTS = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const SECOND_CHECK_DIGIT_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

export function cnpjValidator(cnpj: string): boolean {
  cnpj = sanitizeDocument(cnpj);

  if (cnpj === '') return false;

  if (cnpj.length !== 14) return false;

  if (!/^[A-Z0-9]{12}\d{2}$/i.test(cnpj)) return false;

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj === '00000000000000' ||
    cnpj === '11111111111111' ||
    cnpj === '22222222222222' ||
    cnpj === '33333333333333' ||
    cnpj === '44444444444444' ||
    cnpj === '55555555555555' ||
    cnpj === '66666666666666' ||
    cnpj === '77777777777777' ||
    cnpj === '88888888888888' ||
    cnpj === '99999999999999'
  )
    return false;

  const base = cnpj.substring(0, 12);
  const characters = cnpj.substring(12);
  const firstDigit = calculateCheckDigit(base, FIRST_CHECK_DIGIT_WEIGHTS);
  const secondDigit = calculateCheckDigit(`${base}${firstDigit}`, SECOND_CHECK_DIGIT_WEIGHTS);

  if (firstDigit !== Number(characters.charAt(0))) return false;
  if (secondDigit !== Number(characters.charAt(1))) return false;

  return true;
}

function calculateCheckDigit(value: string, weights: number[]) {
  const sum = value.split('').reduce((total, character, index) => {
    return total + getCharacterValue(character) * weights[index];
  }, 0);
  const result = 11 - (sum % 11);

  return result >= 10 ? 0 : result;
}

function getCharacterValue(character: string) {
  return character.toUpperCase().charCodeAt(0) - 48;
}
